export default __webpack_public_path__ + "static/media/santa-maria-13.409f854f.jpg";